export default __webpack_public_path__ + "static/winter25-23c13b112d4316ef2504fa5b7cdbe582.webp";